module.exports = __webpack_public_path__ + "static/media/0326_IMG_LE_POISSONNIER.f184b254.webp";